import api from '@/api/api';
import { Icon, Dialog, Toast, Cell } from 'vant';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    [Icon.name]: Icon,
    [Cell.name]: Cell,
  }
})
export default class InterviewEvaluation extends Vue {

  testList: unknown = [];

  mounted() {
    this.getEvaluations();
  }

  // 获取考试列表
  getEvaluations() {
    const wechatUser = JSON.parse(sessionStorage.getItem('wechatUser') || '');
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      loadingType: 'spinner',
      duration: 0,
    });
    api.getEvaluationsByOpenId({ openId: wechatUser.openid }).then(
      (res: any) => {
        Toast.clear();
        this.testList = res.evaluateInfos || [];
      }
    ).catch((error: string) => {
      Toast.clear();
      Dialog.alert({
        title: '提示',
        message: error,
      });
    })
  }

  // 跳转一般问卷答题
  toExame(id: string) {
    const token = btoa(encodeURI(`evaluateId=${id}`));
    const url = `${process.env.VUE_APP_ExameAnswer_Link}/#/general/mobile-answers/answer?token=${token}`;
    window.open(url, 'blank');
  }
}